export const SET_PLAYING_VIDEO_W = "SET_PLAYING_VIDEO_W";
export const SET_PENDING_WORKOUT = "SET_PENDING_WORKOUT";
export const SET_NEXT_WORKOUTS = "SET_NEXT_WORKOUTS";
export const SET_TRENDING_WORKOUT = "SET_TRENDING_WORKOUT";
export const SET_WEEK_WORKOUTS = "SET_WEEK_WORKOUTS";
export const SET_GROUPED_WORKOUTS = "SET_GROUPED_WORKOUTS";

export const SET_CURRENT_WATCHED = "SET_CURRENT_WATCHED";
